import { render, staticRenderFns } from "./Categorie.vue?vue&type=template&id=3814a203&scoped=true&"
import script from "./Categorie.vue?vue&type=script&lang=js&"
export * from "./Categorie.vue?vue&type=script&lang=js&"
import style0 from "./Categorie.vue?vue&type=style&index=0&id=3814a203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814a203",
  null
  
)

export default component.exports